var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"my-1"},[_c('v-col',{staticClass:"py-0 break-container"},[_c('span',{staticClass:"break-text"},[_vm._v(_vm._s(_vm.$t("commons.break")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }